import axios from 'axios';
import { getAuth } from 'firebase/auth';
import config from 'config';

const apiUrl = config.apiUrl;

export const generateICPForSegment = async (taskId, segmentName) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error('No authenticated user found');
  }

  try {
    const token = await user.getIdToken();
    const response = await axios.post(
      `${apiUrl}/lpcompare/generate-icp-for-segment/`,
      {
        task_id: taskId,
        segment_name: segmentName
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('An error occurred:', error);
    throw error;
  }
};
